export const MANAGEMENT_PAGE_SIZE = 10;
